export default "__VITE_ASSET__BUW_izlz__"